const baseConfig = {
    production: false,
    debugMode: true,
};

//! environment antiguo de catastro (no se esta utilizando actualmente)
export const env = {
    ...baseConfig,
    url_base: 'https://dev.ayudacatastro.co',
    api: '/api',
    crm: '/crm',
    api_end: '/api.php',
    asistente: '/asistente',
    yo: 'DESARROLLO',

    //routes
    module: {
        //list the enpoints
        mailing_admin: '/administracion/mailing.php',
        mailing_pqrsf: '/pqrsf/mailing_pqrsf.php',
        mailing_support: '/soporte/mailing_support.php',
        ws_pqrsf: '/pqrsf/ws_pqrsf.php',
        ia_general_asis: '/crm/asistente/ia_general.php',
        agenteAPI: '/agenteAPI.php',
        asistenteAudio: '/asistente/',
        entorno: 'DESARROLLO',
        pdf_rad: '/pdf_file/radicado_general.php',
        pdf_rad_2: '/pdf_file/radicado.php',
        api_ws: '/whatsapp/ws_api.php'
    }
}


//! environment antiguo de catastro (no se esta utilizando actualmente)
export const env2 = {
    ...baseConfig,
    url_base: 'https://api.cic-ware.com',
    api_1: '/api-1',
    api_end: '/api.php',
    asistente: '/asistente',

    //routes
    module: {
        //list the enpoints
        ia_general_end: '/ia_general.php',
        entorno: 'DESARROLLO'
    }
}


//! environment antiguo de catastro (no se esta utilizando actualmente)
export const python = {
    ...baseConfig,
    url_base: 'https://dev.api.catastroantioquia-mas.com:5000/ask',
    url_ws: 'wss://dev.api.catastroantioquia-mas.com:5000/ws',
    url_asistente: 'https://dev.catia.catastroantioquia-mas.com:5000/catia',
    url_asistente_cambiante: 'https://dev.catia.catastroantioquia-mas.com:5000/',
    pdf_rad: '/pdf_file/radicado_general.php',
    pdf_rad_2: '/pdf_file/radicado.php',
}



//*API imparables
export const envPython = {
    production: false,
    debugMode: true,


    url_base: 'https://dev.api.imparables.cic-ware.com:5012/ask',
    url_excel: 'https://dev.api.imparables.cic-ware.com:5016/ask',
    imageBaseUrl: 'https://dev.imparables.cic-ware.com/assets/images/noticias',
    url_ia: 'https://n8n.cic-ware.com/webhook/brujula_a'
}
